import { Component, OnInit, Inject, ViewChild, ViewChildren, ElementRef } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as XLSX from 'xlsx';
import { ToastrService } from 'ngx-toastr';
import { RMconfigurationService } from 'src/app/services/rmconfiguration.service';

@Component({
  selector: 'app-preventive-dialog',
  templateUrl: './preventive-dialog.component.html',
  styleUrls: ['./preventive-dialog.component.scss']
})
export class PreventiveDialogComponent implements OnInit {

  @ViewChild('fileInput') fileInput!: ElementRef;
  file: any = {
    Technology: [],
    TaskType: [],
    Tool: [],
    Frequency: [],
    Task: [],
    WOType: [],
    FailureMode: [],
    Priority: [],
    DelayTime: [],
    Technician: []
  };

  isAccess: any;
  isWrite: any;

  constructor(public dialogRef: MatDialogRef<PreventiveDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, public toaster: ToastrService, private RMConfigurationService: RMconfigurationService,) { }

  ngOnInit(): void {
    this.isAccess = this.RMConfigurationService.rmpmAccess;
    this.isWrite = this.RMConfigurationService.rmpmWrite;
   }

  openFile() {
    this.fileInput.nativeElement.click()
  }

  readExcel(event: any, name: any) {
    this.file = event.target.files[0];
    const fileName = this.file.name;
    const validExtensions = ['.xlsx', '.xls', '.xlsb'];

    // Check 1: Validate file extension
    const isExcel = validExtensions.some(ext => fileName.toLowerCase().endsWith(ext));
    if (!isExcel) {
      this.toaster.warning('Invalid file type. Please upload an Excel file (.xlsx, .xls, .xlsb).');
      event.target.value = ''; // Clear the file input
      return;
    }

    // Check 2: Validate file name starts with PM_Configuration and ends optionally with numbers
    const baseName = fileName.split('.').slice(0, -1).join('.'); // remove extension
    // const namePattern = /^RM_Configuration([\s\d\(\)]*)$/;
    const namePattern = /^(RM|PM)_Configuration([\s\d\(\)]*)$/;

    if (!namePattern.test(baseName)) {
      this.toaster.warning('Please check the file format and content before uploading');
      event.target.value = '';
      return;
    }
    let fileReader = new FileReader();
    fileReader.readAsArrayBuffer(this.file);
    fileReader.onload = (e) => {
      let arrayBuffer: any = fileReader.result;
      var data = new Uint8Array(arrayBuffer);
      var arr = new Array();
      for (var i = 0; i != data.length; ++i)
        arr[i] = String.fromCharCode(data[i]);
      var bstr = arr.join("");
      var workbook = XLSX.read(bstr, { type: "binary" });
      console.log(workbook);
      for (var i = 0; i < workbook.SheetNames.length; i++) {
        var sheet_name = workbook.SheetNames[i];
        var worksheet = workbook.Sheets[sheet_name];
        if (sheet_name == "Activity Type")
          this.file.Technology = XLSX.utils.sheet_to_json(worksheet, { raw: true });
        else if (sheet_name == "Tool")
          this.file.Tool = XLSX.utils.sheet_to_json(worksheet, { raw: true });
        else if (sheet_name == "Frequency")
          this.file.Frequency = XLSX.utils.sheet_to_json(worksheet, { raw: true });
        else if (sheet_name == "Task Type")
          this.file.TaskType = XLSX.utils.sheet_to_json(worksheet, { raw: true });
        else if (sheet_name == "Task")
          this.file.Task = XLSX.utils.sheet_to_json(worksheet, { raw: true });
        else if (sheet_name == "WOType")
          this.file.WOType = XLSX.utils.sheet_to_json(worksheet, { raw: true });
        else if (sheet_name == "FailureMode")
          this.file.FailureMode = XLSX.utils.sheet_to_json(worksheet, { raw: true });
        else if (sheet_name == "Priority")
          this.file.Priority = XLSX.utils.sheet_to_json(worksheet, { raw: true });
        else if (sheet_name == "DelayTime")
          this.file.DelayTime = XLSX.utils.sheet_to_json(worksheet, { raw: true });
        else if (sheet_name == "BreakdownConfiguration")
          this.file.BreakdownConfiguration = XLSX.utils.sheet_to_json(worksheet, { raw: true });
        else if (sheet_name == "Technician")
          this.file.Technician = XLSX.utils.sheet_to_json(worksheet, { raw: true });
      }
      const hasAnyData =
  (this.file.Technology?.length ?? 0) > 0 ||
  (this.file.Tool?.length ?? 0) > 0 ||
  (this.file.Frequency?.length ?? 0) > 0 ||
  (this.file.TaskType?.length ?? 0) > 0 ||
  (this.file.Task?.length ?? 0) > 0 ||
  (this.file.WOType?.length ?? 0) > 0 ||
  (this.file.FailureMode?.length ?? 0) > 0 ||
  (this.file.Priority?.length ?? 0) > 0 ||
  (this.file.DelayTime?.length ?? 0) > 0 ||
  (this.file.BreakdownConfiguration?.length ?? 0) > 0 ||
  (this.file.Technician?.length ?? 0) > 0;

if (!hasAnyData) {
 this.toaster.warning('The uploaded Excel file is empty or contains no valid rows.');
  event.target.value = '';
  return;
      }
      this.dialogRef.close(this.file);
    }
  }


  onCancelClick(): void {
    this.dialogRef.close();
  }

}
